document.addEventListener("DOMContentLoaded", function () {
  // Select all elements with the class 'wpcf7-form-control' and set them to required
  const formControls = document.querySelectorAll(".wpcf7-form-control");
  formControls.forEach(function (control) {
    control.required = true;
  });

  // Select all elements with the class 'wpcf7-form' and remove the 'novalidate' attribute
  const forms = document.querySelectorAll(".wpcf7-form");
  forms.forEach(function (form) {
    form.removeAttribute("novalidate");
  });
});
